import React from "react"
export const MoneyExchangeFirstStep = ({url}) => {



    return (
        <div className="payout-container">
            <div className="discount-offer-header">
                {/* <b>Wybierz metodę wypłaty</b> */}
            </div>
            <div className="offer-panel payout-options-container">
                <div className="payout-option">
                    <p><b> &darr;</b> Poniżej znajdziesz link do wypłaty <b> &darr;</b></p>
                    <a target="_blank" rel="noopener noreferrer" href={url}><button><b>Przejdź do wypłaty &rarr;</b></button></a>
                    <p><b>Uwaga!</b> Upewnij się że wpisujesz dane które podałeś tu przy zakładaniu konta!</p>
                </div>
            </div>

        </div>
    )
}